<template>
  <v-expansion-panels
    multiple
    accordion
  >
    <v-expansion-panel
      :key="0"
    >
      <v-expansion-panel-header class="pl-1">
        <span>
          <v-icon right>fas fa-tree</v-icon>
          {{ schemaKey ? schemaKey : name }}
        </span>
      </v-expansion-panel-header>
      <v-divider />
      <v-expansion-panel-content class="py-3">
        <Leef
          v-model="cloneRequestSchema"
          :schema="schema"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'Tree',

  components: {
    Leef: () => import('./Leef.vue')
  },

  props: ['name', 'schemaKey', 'schema', 'value'],

  data() {
    return {
      cloneRequestSchema: undefined
    }
  },

  watch: {
    cloneRequestSchema() {
      this.$emit('input', this.cloneRequestSchema)
    }
  },

  created() {
    this.cloneRequestSchema = cloneDeep(this.value)
    if (this.cloneRequestSchema === '' || this.cloneRequestSchema === undefined) this.cloneRequestSchema = {}
  }
}
</script>

<style></style>
